export default {"src":"/_next/static/media/pause.bb7bbff9.svg","height":16,"width":16};